import { makeAutoObservable } from "mobx";
import { RArray, RSet } from "../../collections";
import { MAX_CROSS_SELLING_ITEM_COUNT, } from "./ICrossSellingCreator";
export class ProductCardCrossSellingCreator {
    constructor(params) {
        this.purchaseOrderPayload = params.purchaseOrderPayload;
        this.crossSellingItemInstanceListService =
            params.crossSellingItemInstanceListService;
        this.crossSellingItemInstanceFactory =
            params.crossSellingItemInstanceFactory;
        this._items = RArray.empty();
        this.inputProductTypeIds = RSet.empty();
        makeAutoObservable(this);
    }
    setInputProductTypeIds(inputProductTypeIds) {
        this.inputProductTypeIds = inputProductTypeIds;
        this._items = this.crossSellingItemInstanceFactory.create({
            inputProductTypeIds,
            sequenceNumber: Math.random(),
        });
    }
    get excludedProductTypeIds() {
        return this.purchaseOrderPayload.productTypeIds.union(this.inputProductTypeIds);
    }
    get items() {
        return this._items
            .filtered((crossSellingItemInstance) => this.crossSellingItemInstanceListService.shouldAppearInCrossSellingList(crossSellingItemInstance, this.excludedProductTypeIds))
            .take(MAX_CROSS_SELLING_ITEM_COUNT);
    }
    get selectedItems() {
        return this.items.mapOptional(({ itemCreator, quantity, kind }) => {
            if (quantity.isZero) {
                return null;
            }
            return [itemCreator, quantity, kind];
        });
    }
    shuffle() {
        // NOTICE Intentionally empty
    }
}
